export const INVALID_MARKUP_ERROR =
  'Please correct to {{ membership.phone_number }} and/or {{ membership.id }}.';

export const PHYSICAL_RECEIPT_LABEL_OVERRIDE_HELPER_TEXT =
  'Override the label shown for this offer on the physical receipt. Note: NCR RLM max character limit is 16.';

export const RECEIPT_LABEL_ALPHANUMERIC_ERROR = 'Only letters, numbers, and spaces are allowed.';
